import React, { useState } from "react";
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogContentText,
  Stack, Typography, useTheme,
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearAbsData } from "app/store/absSlice";
import { AbLinkOrder } from "./AbLinkOrder";

export default function AbOrderSuccess(props) {
  const theme = useTheme();
  const { open, setOpen, currentOrder, setOpenSuccessOrder, setLinkOrderStatus } = props;
  const [openLinkOrder, setOpenLinkOrder] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
    dispatch(clearAbsData());
    setOpenLinkOrder(false);
  };
  const handleNewOrder = () => {
    setOpenSuccessOrder(false);
    navigate("/order/create-abs-order");
  };
  const handlePartOrder = () => {
    setOpenSuccessOrder(false);
    navigate("/order/create-abs-part-order");
  };
  const handleLinkOrder = () => {
    setOpen(false);
    setOpenLinkOrder(true);
    setLinkOrderStatus(false);
  };

  return (
    <>
      <Dialog
        open={open}
        fullWidth
        maxWidth="xs"
        onClose={handleClose}
        PaperProps={{ sx: { m: { xs: 2, sm: 4 }, width: { xs: "calc(100% - 32px)", sm: "100%" } } }}
      >
        <DialogActions>
          <Button onClick={handleClose} autoFocus color="inherit">
            <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
          </Button>
        </DialogActions>
        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
          <DialogContentText
            id="alert-dialog-description"
            align="center"
            component="div"
            sx={{ color: theme.palette.text.primary }}
          >
            <Typography component="p" sx={{ wordBreak: "break-word" }}>
              You have selected AB with AB number {currentOrder[0]?.abNumber}.
              Please choose the operation mode you would like to proceed with.
            </Typography>

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1.5}
              justifyContent="center"
              alignItems="stretch"
              sx={{ mt: 2.5 }}
            >
              <Button color="secondary" variant="contained" onClick={handleNewOrder}>
                New Order
              </Button>
              <Button color="secondary" variant="contained" onClick={handlePartOrder}>
                Part Order
              </Button>
              <Button color="secondary" variant="contained" onClick={handleLinkOrder}>
                Link to an Order
              </Button>
            </Stack>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      {openLinkOrder && (
        <AbLinkOrder setLinkOrderStatus={setLinkOrderStatus} setOpenLinkOrder={setOpenLinkOrder} />
      )}
    </>
  );
}